import gql from 'graphql-tag';
import { gqlMutation } from 'services/aws/utils/mutate';
import { appSyncClient } from 'services/aws/app-sync';

export const QUERY_GET_PERSON_FROM_INTEGRATION = gql`
  query getPersonFromIntegration(
    $entityId: ID!
    $integrationType: IntegrationType!
    $externalPersonId: ID!
  ) {
    getPersonFromIntegration(
      entityId: $entityId
      integrationType: $integrationType
      externalPersonId: $externalPersonId
    ) {
      externalPersonId
      firstname
      lastname
      email
      birthdate
    }
  }
`;

export const QUERY_GET_PERSONS_FROM_INTEGRATION = gql`
  query getPersonsFromIntegration(
    $entityId: ID!
    $integrationType: IntegrationType!
  ) {
    getPersonsFromIntegration(
      entityId: $entityId
      integrationType: $integrationType
    ) {
      externalPersonId
      firstname
      lastname
      email
      birthdate
      gender
    }
  }
`;

export const QUERY_GET_EXTERNAL_PERSON_MAPPINGS_BY_EXTERNAL_PERSONID = gql`
  query getExternalPersonMappingsByExternalPersonId(
    $entityId: ID!
    $personId: ID!
  ) {
    getExternalPersonMappingsByExternalPersonId(
      entityId: $entityId
      personId: $personId
    ) {
      id
      personId
      externalPersonId
      entityId
      integrationType
      meta
    }
  }
`;

export const MUTATION_ADD_EXTERNAL_PERSON_MAPPING = gql`
  mutation addExternalPersonMapping(
    $personId: ID!
    $externalPersonId: ID!
    $entityId: ID!
    $integrationType: IntegrationType
  ) {
    addExternalPersonMapping(
      input: {
        personId: $personId
        externalPersonId: $externalPersonId
        entityId: $entityId
        integrationType: $integrationType
      }
    ) {
      id
      personId
      externalPersonId
      entityId
    }
  }
`;

export const MUTATION_REMOVE_EXTERNAL_PERSON_MAPPING = gql`
  mutation archiveExternalPersonMapping($id: ID!) {
    archiveExternalPersonMapping(id: $id)
  }
`;

export const deleteExternalPersonMapping = async ({ id }) => {
  return new Promise(async resolve => {
    await gqlMutation(appSyncClient, {
      mutation: MUTATION_REMOVE_EXTERNAL_PERSON_MAPPING,
      variables: { id },
      skip: !id,
      update: (cache, { data: { archiveExternalPersonMapping } }) => {
        if (archiveExternalPersonMapping) {
          resolve();
        }
      }
    });
  });
};
